export default __webpack_public_path__ + "static/media/star1.ef01597f.gif";